<template>
  <div>
    <LastWorkOrder
      :onlyLastWorkOrder="lastWorkOrder"
    />
  </div>
</template>

<script>


import LastWorkOrder from '@/views/sites/siteDashboard-old/LatestWorkOrder/LastWorkOrder.vue';
import { mapGetters } from 'vuex';

export default {
    name: 'LatestWorkOrder',
    components: { LastWorkOrder },
    data() {
        return {
            lastWorkOrder: {},
        };
    },
    computed: {
        ...mapGetters([
            'currentMember',
            'hasPermission',
            'site',
            'client',
        ]),
    },
    created() {
        this.getWorkOrders();
    },
    methods: {
        async getWorkOrders() {
            const queryParams = {
                showallattributes: !!this.hasPermission('showAllAttributes'),
                excludeActivities: true,
                onlyLastWorkOrder: true,
                site: this.site.id,
                client: this.client.id,
                order: 'startdate_desc',
                completionStatus: 'toDo,inProgress,pending,late',
            };
            const { data } = await this.$rq.getWorkOrders(queryParams);
            const workOrder = data.workOrders[0];
            this.lastWorkOrder = workOrder || {};
        },
    },
};
</script>
